/* eslint-disable no-useless-escape */
import {
  COPY,
  DO_NOTHING,
  EMPTYGROUP,
  modalEndConditionState,
  MOVE
} from 'Hooks/useModalEndCondition/useModalEndCondition'
import { atom, selector } from 'recoil'
import {
  ACTION_MOVE_COPY,
  ACTION_SEND_MESSAGE,
  ACTION_SEND_SMS,
  exceptionsState,
  senderConfigState,
  taskConditionsState,
  taskPanelFrequencyState,
  taskState
} from './task'

export const pageState = atom({
  key: 'taskPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    wizardStep: 2,
    idTask: 0,
    exitPage: false
  }
})

export const wizardErrorState = selector({
  key: 'taskWizardErrorState',
  get: ({ get }) => {
    const step1IsEnabled = get(step1IsEnabledState)
    const step2IsEnabled = get(step2IsEnabledState)
    const step3IsEnabled = get(step3IsEnabledState)
    const step4IsEnabled = get(step4IsEnabledState)

    return !(
      step1IsEnabled &&
      step2IsEnabled &&
      step3IsEnabled &&
      step4IsEnabled
    )
  }
})

export const wizardEnableStep1State = selector({
  key: 'taskWizardEnableStep1State',
  get: ({ get }) => {
    const { idTask } = get(pageState)
    const error = get(wizardErrorState)

    return idTask === 0 ? true : !error
  }
})

export const wizardEnableStep2State = selector({
  key: 'taskWizardEnableStep2State',
  get: ({ get }) => {
    const { wizardStep, idTask } = get(pageState)
    const step1IsEnabled = get(step1IsEnabledState)
    const error = get(wizardErrorState)

    let res
    if (idTask > 0) {
      res = (idTask > 0 || wizardStep >= 2) && step1IsEnabled && !error
    } else {
      res = wizardStep >= 2 && step1IsEnabled
    }

    return res
  }
})

export const wizardEnableStep3State = selector({
  key: 'taskWizardEnableStep3State',
  get: ({ get }) => {
    const { wizardStep, idTask } = get(pageState)
    const step1IsEnabled = get(step1IsEnabledState)
    const step2IsEnabled = get(step2IsEnabledState)
    const error = get(wizardErrorState)

    let res
    if (idTask > 0) {
      res =
        (idTask > 0 || wizardStep >= 3) &&
        step1IsEnabled &&
        step2IsEnabled &&
        !error
    } else {
      res = wizardStep >= 3 && step1IsEnabled && step2IsEnabled
    }

    return res
  }
})

export const wizardEnableStep4State = selector({
  key: 'taskWizardEnableStep4State',
  get: ({ get }) => {
    const { wizardStep, idTask } = get(pageState)
    const step1IsEnabled = get(step1IsEnabledState)
    const step2IsEnabled = get(step2IsEnabledState)
    const step3IsEnabled = get(step3IsEnabledState)
    const error = get(wizardErrorState)

    let res
    if (idTask > 0) {
      res =
        (idTask > 0 || wizardStep >= 4) &&
        step1IsEnabled &&
        step2IsEnabled &&
        step3IsEnabled &&
        !error
    } else {
      res =
        wizardStep >= 4 && step1IsEnabled && step2IsEnabled && step3IsEnabled
    }

    return res
  }
})

export const wizardEnableStep5State = selector({
  key: 'taskWizardEnableStep5State',
  get: ({ get }) => {
    const { wizardStep, idTask } = get(pageState)
    const step1IsEnabled = get(step1IsEnabledState)
    const step2IsEnabled = get(step2IsEnabledState)
    const step3IsEnabled = get(step3IsEnabledState)
    const step4IsEnabled = get(step4IsEnabledState)

    let res
    if (idTask > 0) {
      res =
        (idTask > 0 || wizardStep >= 5) &&
        step1IsEnabled &&
        step2IsEnabled &&
        step3IsEnabled &&
        step3IsEnabled &&
        step4IsEnabled
    } else {
      res =
        wizardStep >= 5 &&
        step1IsEnabled &&
        step2IsEnabled &&
        step3IsEnabled &&
        step3IsEnabled &&
        step4IsEnabled
    }

    return res
  }
})

export const step1IsEnabledState = selector({
  key: 'taskWizardstep1IsEnabledState',
  get: ({ get }) => {
    const { Name, CustomerTimeZone } = get(taskState)
    if (!Name || Name.length <= 0) return false
    else if (!CustomerTimeZone) return false
    else return true
  }
})

export const step2IsEnabledState = selector({
  key: 'taskWizardstep2IsEnabledState',
  get: ({ get }) => {
    const { Detail } = get(taskState)
    const {
      SenderEmail,
      CustomSender,
      SenderName,
      SenderReplyTo,
      IdSenderNameField,
      IdSenderEmailField,
      SenderNameSMS,
      IdMessage,
      sernderEmailValid,
      sernderSmsValid
    } = get(senderConfigState)
    const { check, copyValue, emptyValue, moveToValue, moveFromValue } = get(
      modalEndConditionState
    )

    if (Detail.Action !== ACTION_MOVE_COPY) {
      if (!IdMessage) {
        return false
      } else if (Detail.Action === ACTION_SEND_MESSAGE) {
        if (!CustomSender && (!SenderEmail || !SenderName || !SenderReplyTo)) {
          return false
        }
        if (
          CustomSender &&
          (!SenderEmail ||
            !SenderName ||
            !SenderReplyTo ||
            !IdSenderNameField ||
            !IdSenderEmailField)
        ) {
          return false
        }
        if (!sernderEmailValid) {
          return false
        }
      } else if (Detail.Action === ACTION_SEND_SMS) {
        if (!SenderNameSMS) {
          return false
        }
        if (!sernderSmsValid) {
          return false
        }
      }
    }

    // controllo il box dei gruppi
    let ret = true
    if (check === MOVE) {
      ret =
        moveToValue && moveFromValue
          ? moveToValue.value !== moveFromValue.value &&
            moveFromValue.value !== -1 &&
            moveToValue.value !== -1
          : false
    } else if (check === COPY) {
      ret = copyValue ? copyValue.value !== -1 : false
    } else if (check === EMPTYGROUP) {
      ret = emptyValue ? emptyValue.value !== -1 : false
    } else if (check === DO_NOTHING) {
      ret = Detail.Action !== ACTION_MOVE_COPY
    }

    return ret
  }
})

export const step3IsEnabledState = selector({
  key: 'taskWizardstep3IsEnabledState',
  get: ({ get }) => {
    const {
      ApplyConditionsField,
      TaskApplyConditionsField,
      AnagFilterTrue,
      AnagFilterTrueId,
      AnagFilterFalse,
      AnagFilterFalseId,
      OtherFilterTrue,
      OtherFilterTrueId,
      OtherFilterFalse,
      OtherFilterFalseId,
      IncludeGroups,
      ExcludeGroups,
      Filters,
      ApplyConditionsEvent
    } = get(taskConditionsState)
    const fieldValueOk = get(fieldValueOkState)
    if (
      IncludeGroups.length <= 0 &&
      ExcludeGroups.length <= 0 &&
      Filters.length <= 0 &&
      !ApplyConditionsEvent &&
      !ApplyConditionsField &&
      !AnagFilterTrue &&
      !AnagFilterFalse &&
      !OtherFilterTrue &&
      !OtherFilterFalse
    ) {
      return false
    }

    if (ApplyConditionsField) {
      if (
        !TaskApplyConditionsField.FieldValue &&
        TaskApplyConditionsField.IdFieldFilter !== 20 &&
        TaskApplyConditionsField.IdFieldFilter !== 28 &&
        TaskApplyConditionsField.IdFieldFilter !== 29
      ) {
        return false
      }

      if (!TaskApplyConditionsField.IdField) return false
      if (!TaskApplyConditionsField.FieldType) return false
      if (!TaskApplyConditionsField.IdFieldFilter) return false
      if (!fieldValueOk) return false
    }
    if (AnagFilterTrue) {
      if (!AnagFilterTrueId) return false
    }
    if (AnagFilterFalse) {
      if (!AnagFilterFalseId) return false
    }
    if (OtherFilterTrue) {
      if (!OtherFilterTrueId) return false
    }
    if (OtherFilterFalse) {
      if (!OtherFilterFalseId) return false
    }
    return true
  }
})

export const step4IsEnabledState = selector({
  key: 'taskWizardstep4IsEnabledState',
  get: ({ get }) => {
    const { activiteFor, StartDate, EndDate, urlFrequencyEnabled, Url } =
      get(exceptionsState)
    const { Frequency } = get(taskState)
    const { radioAt } = get(taskPanelFrequencyState)
    if (activiteFor === 'FromDate') {
      if (!StartDate) return false
    }
    if (activiteFor === 'FromToDate') {
      if (!StartDate || !EndDate) return false
    }
    if (urlFrequencyEnabled) {
      if (!Url) return false
    }

    // comprende anche il caso Frequency.KindDateFrequency === 'd') {
    if (Frequency.DateFrequency === 0) {
      return false
    }

    if (
      Frequency.DailyFrequency !== 0 &&
      Frequency.StartHour !== 0 &&
      Frequency.StartMinute !== 0
    ) {
      return false
    }

    if (Frequency.StartHour !== 0 && Frequency.DailyFrequency !== 0) {
      return false
    }

    if (Frequency.StartMinute !== 0 && Frequency.DailyFrequency !== 0) {
      return false
    }

    if (!radioAt && Frequency.DailyFrequency === 0) {
      return false
    }

    if (Frequency.KindDateFrequency === 'w') {
      if (Frequency.ChoosenDays.length === 0) {
        return false
      }
    } else if (Frequency.KindDateFrequency === 'm') {
      if (Frequency.ChoosenDays.length === 0) {
        return false
      } else {
        // max 1
        if (Frequency.ChoosenDays[0].FixedDay) {
          if (Frequency.ChoosenDays[0].DayOfMonth === 0) {
            return false
          }
        } else {
          if (
            Frequency.ChoosenDays[0].DayOfWeek === '' ||
            Frequency.ChoosenDays[0].WeekOfMonth === ''
          ) {
            return false
          }
        }
      }
      // "FixedDay":false
    } else if (Frequency.KindDateFrequency === 'y') {
      if (Frequency.ChoosenDays.length === 0) {
        return false
      } else {
        // max 1
        if (Frequency.ChoosenDays[0].FixedDay) {
          if (Frequency.ChoosenDays[0].DayOfMonth === 0) {
            return false
          }
        } else {
          if (
            Frequency.ChoosenDays[0].DayOfWeek === '' ||
            Frequency.ChoosenDays[0].WeekOfMonth === ''
          ) {
            return false
          }
        }
        if (Frequency.ChoosenDays[0].Month === 0) {
          return false
        }
      }
    }

    // const hUgua = +endBOTime.hours === +startBOTime.hours
    // const hMino = +endBOTime.hours < +startBOTime.hours
    // const mMinU = +endBOTime.minutes <= +startBOTime.minutes

    // if (hMino) {
    //   return false
    // } else if (hUgua && mMinU) {
    //   return false
    // }

    return true
  }
})

export const step5IsEnabledState = selector({
  key: 'taskWizardstep5IsEnabledState',
  get: ({ get }) => {
    return true
  }
})

export const fieldValueOkState = selector({
  key: 'taskfieldValueOkState',
  get: ({ get }) => {
    const { TaskApplyConditionsField } = get(taskConditionsState)

    let fieldValue = TaskApplyConditionsField.FieldValue
    let fieldOk = false

    if (TaskApplyConditionsField.FieldType !== 3) {
      fieldValue = fieldValue.trim()
    }

    if (
      TaskApplyConditionsField.IdFieldFilter !== 13 &&
      TaskApplyConditionsField.IdFieldFilter !== 14 &&
      TaskApplyConditionsField.IdFieldFilter !== 15 &&
      TaskApplyConditionsField.IdFieldFilter !== 16 &&
      TaskApplyConditionsField.IdFieldFilter !== 20 &&
      TaskApplyConditionsField.IdFieldFilter !== 28 &&
      TaskApplyConditionsField.IdFieldFilter !== 29
    ) {
      let re = null

      if (TaskApplyConditionsField.FieldType === 1) {
        // Intero
        re = /^[+-]?\d+$/
      } else if (TaskApplyConditionsField.FieldType === 2) {
        // Decimale
        re = /^[+-]?\d+([.,]\d+)?$/
      } else if (TaskApplyConditionsField.FieldType === 3) {
        // Carattere
        re = /.*/
      } else if (
        TaskApplyConditionsField.FieldType >= 5 &&
        TaskApplyConditionsField.FieldType <= 12
      ) {
        // Data
        if (
          TaskApplyConditionsField.IdFieldFilter === 23 ||
          TaskApplyConditionsField.IdFieldFilter === 24 ||
          TaskApplyConditionsField.IdFieldFilter === 25
        ) {
          if (
            TaskApplyConditionsField.FieldType === 5 ||
            TaskApplyConditionsField.FieldType === 7
          ) {
            // Data dd/MM/yyyy
            // Data MM/dd/yyyy

            re = /^\d{2}[\/-]\d{2}[\/-]\d{4}$/
          } else if (
            TaskApplyConditionsField.FieldType === 6 ||
            TaskApplyConditionsField.FieldType === 8
          ) {
            // Data dd/MM
            // Data MM/dd
            re = /^\d{2}[\/-]\d{2}$/
          } else if (TaskApplyConditionsField.FieldType === 9) {
            // Data yyyyMMdd
            re = /^\d{8}$/
          } else if (TaskApplyConditionsField.FieldType === 10) {
            // Data MMdd
            re = /^\d{4}$/
          } else if (TaskApplyConditionsField.FieldType === 11) {
            // Data yyyy-MM-dd
            re = /^\d{4}[\/-]\d{2}[\/-]\d{2}$/
          }
        } else {
          re = /^[+-]?\d+$/
        }
      } else {
        re = /.*/
      }

      fieldOk = re.test(fieldValue)
    } else {
      fieldOk = fieldValue === ''
    }
    return fieldOk
  }
})

export const slotTimeIsValid = selector({
  key: 'taskWizardstep4SlotTimeIsValid',
  get: ({ get }) => {
    const { startBOTime, endBOTime } = get(exceptionsState)
    const hMagg = +endBOTime.hours > +startBOTime.hours
    const hUgua = +endBOTime.hours === +startBOTime.hours
    const hMino = +endBOTime.hours < +startBOTime.hours

    const mMagg = +endBOTime.minutes > +startBOTime.minutes

    if (hMagg) {
      return true
    } else if (hMino) {
      return false
    } else if (hUgua) {
      // i minuti devono essere maggiori
      return mMagg
    }
    return false
  }
})
